import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
// import { media } from "src/styles/breakpoints"
import BaseIcon from "src/components/Base/BaseIcon"

const Breadcrumbs = ({ items, className }) => {
  return (
    <Wrapper className={className}>
      {items.map(({ name, path }, index) => (
        <React.Fragment key={index}>
          <BreadcrumbsItem to={path}>{name}</BreadcrumbsItem>
          {index < items.length - 1 && (
            <BreadcrumbsIcon name="chevron-right" source="feather" />
          )}
        </React.Fragment>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 75px;
  font-size: 15px;
  color: #b4b3b8;
`

const BreadcrumbsItem = styled(Link)`
  transition: 0.15s;

  &:hover {
    color: ${(p) => p.theme.color.primary};
  }
`

const BreadcrumbsIcon = styled(BaseIcon)`
  width: 18px;
  height: 18px;
  margin: 0 10px;
  color: #46cad8;
`

export default Breadcrumbs
